/* Product cards (snippets/aurtrs-card.liquid) and the collection filter bar
 * (sections/aurtrs-main-collection.liquid).
 *
 * Colour dots: clicking one shows that colour's image and price and points the
 * card's links at that variant.
 * Filters: Color (a colour family, e.g. Blue = several colour names) and
 * Weight hide the cards that have no such variant; a colour filter also
 * switches each remaining card to its matching colour. State lives in the URL
 * (?color=Blue&weight=15) so the "Shop by colour / weight" tiles can link to it. */
(function () {
  function pick(dot) {
    var card = dot.closest('[data-at-card]');
    card.querySelectorAll('.at-pcard__dot').forEach(function (d) {
      var on = d === dot;
      d.classList.toggle('is-on', on);
      d.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var img = card.querySelector('.at-pcard__img:not(.at-pcard__img--hover)');
    if (img && dot.dataset.src) {
      img.removeAttribute('srcset');
      img.src = dot.dataset.src;
      var hover = card.querySelector('.at-pcard__img--hover');
      if (hover) hover.remove();
    }
    if (dot.dataset.url) {
      card.querySelectorAll('[data-at-card-link]').forEach(function (a) { a.href = dot.dataset.url; });
    }
    var price = card.querySelector('.at-pcard__price');
    if (price && dot.dataset.price) price.textContent = dot.dataset.price;
  }

  document.addEventListener('click', function (e) {
    var dot = e.target.closest('.at-pcard__dot');
    if (dot) pick(dot);
  });

  function initFilters() {
    var bar = document.querySelector('[data-at-filters]');
    if (!bar) return;
    var items = document.querySelectorAll('.at-coll-grid__item');
    var empty = bar.querySelector('[data-at-filter-empty]');
    var reset = bar.querySelector('[data-at-filter-reset]');
    var params = new URLSearchParams(location.search);
    var state = { color: params.get('color') || '', weight: params.get('weight') || '' };

    function option(group, value) {
      var found = null;
      bar.querySelectorAll('[data-filter="' + group + '"]').forEach(function (b) {
        if (b.dataset.value.toLowerCase() === value.toLowerCase()) found = b;
      });
      return found;
    }

    function apply() {
      var color = state.color ? option('color', state.color) : null;
      var weight = state.weight ? option('weight', state.weight) : null;
      var names = color ? color.dataset.match.split('|') : [];
      var shown = 0;
      items.forEach(function (li) {
        var card = li.querySelector('[data-at-card]');
        var ok = true;
        if (color) {
          var dot = null;
          card.querySelectorAll('.at-pcard__dot').forEach(function (d) {
            if (!dot && names.indexOf(d.dataset.color) > -1) dot = d;
          });
          ok = !!dot;
          if (dot && !dot.classList.contains('is-on')) pick(dot);
        }
        if (ok && weight) {
          ok = ('|' + (card.dataset.weights || '') + '|').indexOf('|' + weight.dataset.value + '|') > -1;
        }
        li.hidden = !ok;
        if (ok) shown++;
      });
      bar.querySelectorAll('[data-filter]').forEach(function (b) {
        var on = b === color || b === weight;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      bar.querySelectorAll('[data-at-filter-group]').forEach(function (g) {
        var picked = g.dataset.atFilterGroup === 'color' ? color : weight;
        g.querySelector('[data-at-filter-value]').textContent = picked ? ': ' + picked.dataset.label : '';
        g.classList.toggle('is-set', !!picked);
      });
      if (reset) reset.hidden = !(color || weight);
      if (empty) empty.hidden = shown > 0;
    }

    function sync() {
      var next = new URLSearchParams(location.search);
      ['color', 'weight'].forEach(function (k) {
        if (state[k]) next.set(k, state[k]); else next.delete(k);
      });
      var q = next.toString();
      history.replaceState(null, '', location.pathname + (q ? '?' + q : '') + location.hash);
    }

    bar.addEventListener('click', function (e) {
      var b = e.target.closest('[data-filter]');
      if (b) {
        var group = b.dataset.filter;
        state[group] = state[group].toLowerCase() === b.dataset.value.toLowerCase() ? '' : b.dataset.value;
        b.closest('details').open = false;
      } else if (e.target.closest('[data-at-filter-reset]')) {
        state.color = '';
        state.weight = '';
      } else {
        return;
      }
      sync();
      apply();
    });
    document.addEventListener('click', function (e) {
      bar.querySelectorAll('details[open]').forEach(function (d) {
        if (!d.contains(e.target)) d.open = false;
      });
    });

    if (state.color || state.weight) apply();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFilters);
  else initFilters();
})();
